import { parseMcleodDate, formatDateForMcleod } from "../utils/dateHelpers";

export default class StopSerializer {
  static serialize(data) {  
    const payload =  {
      ...data,
      id: data.id,
      city_name: data.cityName,
      state: data.state,
      sched_arrive_early: formatDateForMcleod(data.schedArriveEarly),
      sched_arrive_late: formatDateForMcleod(data.schedArriveLate),
      eta: formatDateForMcleod(data.eta),
      actual_arrival: formatDateForMcleod(data.actualArrival),
      actual_departure: formatDateForMcleod(data.actualDeparture),
      stop_type: data.stopType,
      order_sequence: data.orderSequence,
      location_name: data.locationName,
      address: data.address,
      address2: data.address2,
      contact_name: data.contactName,
      phone: data.phone
    };

    const customProperties = [
      "cityName",
      "schedArriveEarly",
      "schedArriveLate",
      "actualArrival",
      "actualDeparture",
      "stopType",
      "orderSequence",
      "locationName",
      "contactName"
    ];

    customProperties.forEach(prop => delete payload[prop]);
    return payload;
  }

  static deSerialize(data) {
    return {
      ...data,
      id: data.id,
      cityName: data.city_name,
      state: data.state,
      schedArriveEarly: parseMcleodDate(data.sched_arrive_early),
      schedArriveLate: parseMcleodDate(data.sched_arrive_late),
      actualArrival: parseMcleodDate(data.actual_arrival),
      actualDeparture: parseMcleodDate(data.actual_departure),
      eta: parseMcleodDate(data.eta),
      stopType: data.stop_type,
      orderSequence: data.order_sequence,
      locationId: data.location_id,
      locationName: data.location_name,
      address: data.address,
      address2: data.address2,
      contactName: data.contact_name,
      phone: data.phone
    };
  }
}